/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Cognos Analytics Home (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'ca-content/content/content',
	'react'
], function (content, React) {

	const { SamplesTabView } = content;
	class SamplesTab {
		constructor(options) {
			this.glassContext = options.glassContext;
		}

		render(options) {
			return (React.createElement(SamplesTabView, {
				glassContext: this.glassContext,
				options: options
			}));
		}

	}
	return SamplesTab;
});